import React, { useState, useEffect } from "react";
import { Tab, Tabs, TabList } from "react-tabs";
import { useDispatch, useSelector } from "react-redux";

import { setCategory, setCategoryIndex } from "../../store/markingSlice";
import { MarkingTable } from "./";
import * as commonApi from "../../api/markingApi";
import { Header, LoadingSpinner } from "../../components/Shared";
import { isEmptyArray, isNullOrEmpty } from "../../util";
import { Common, Marking, Subjects, NavigationBar } from "../../helper";
import { setSelect } from "../../store/stylesSlice";

import "../../App.scss";
import "../../assets/stlyes/marking.scss";

const Markings = () => {
  const markingData = useSelector((state) => state.marking);
  const isNavCollapsed = useSelector((state) => state.styleData.isNavCollapsed)
  const [categoryName, setCategoryName] = useState(markingData.categoryNameOne);
  const [tabsData, setTabsData] = useState([]);
  const [headersData, setHeadersData] = useState([]);
  const [mainHeadersData, setMainHeadersData] = useState([]);
  const [_subjectClassId, setSubjectClassId] = useState("");
  const [_classId, setClassId] = useState("");
  const [className, setClassName] = useState("");
  const [subjectName, setSubjectName] = useState("");
  const [year, setYear] = useState();
  const [tableBodyData, setTableBodyData] = useState([]);
  const [tempHeadersData, setTempHeadersData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  const dispatch = useDispatch();
  const getHeadersAndTabs = async (id, cat) => {
    setIsLoading(true)
    setYear();
    const data = { id: id }
    setYear();
    const response = await commonApi.fetchSubject(data);
    const result = response && response.Items.category;
    if (markingData.categoryIndex === 0) {
      setCategoryName(result[0]?.name);
      dispatch(setCategory(result[0]?.name));
    }
    if (!isEmptyArray(result)) {
      setTabsData(result);
      setMainHeadersData(result);
      setHeadersData(result);
      setYear(response.Items.year);
    }
    let _headers = response.Items.category?.filter((ele) => ele.name === (markingData.categoryIndex === 0 ? response.Items.category[0].name : cat) && { description: markingData.categoryIndex === 0 ? response.Items.category[0].name : cat, isKPI: response.Items.category[0].description[0].name, identifier: response.Items.category[0].description[0].identifier });
    let updatedData = _headers[0]?.description?.map((ele) => { return { description: ele.name, isKPI: ele.isKPI, identifier: ele.identifier } });
    updatedData?.push({ description: `${!(markingData.categoryIndex === 0) ? markingData.categoryNameOne : response?.Items?.category[0]?.name} ${Marking.Attainment}`, actual: Marking.Actual, predicted: Marking.Predicted, isKPI: false, identifier: Marking.Ff });
    updatedData?.unshift({ description: " ", isKPI: false, identifier: Marking.Dd });
    setHeadersData(updatedData && [...updatedData]);
    const subjectClassId = markingData.subjectId;
    const className = markingData.className;
    const subjectName = markingData.subjectName;
    const classId = markingData.classId;
    (!isNullOrEmpty(subjectClassId) || !isNullOrEmpty(className) || !isNullOrEmpty(subjectName) || !isNullOrEmpty(classId)) && _fetchCategoryMark(subjectName, classId, markingData.categoryIndex === 0 ? response.Items.category[0].name : markingData.categoryNameOne, response.Items.year, subjectClassId)
  }

  const _fetchCategoryMark = async (subjectName, classId, categoryName, _year, subjectId) => {
    if (subjectName === Subjects.Empty) {
      switch (subjectId.slice(0, 2)) {
      case Subjects.WritingId:
        subjectName = Subjects.Writing;
        break;
      case Subjects.MathId:
        subjectName = Subjects.Maths;
        break;
      case Subjects.ReadingId:
        subjectName = Subjects.Reading;
        break;
      case Subjects.ScienceId:
        subjectName = Subjects.Science;
        break;
      case Subjects.PEId:
        subjectName = Subjects.PE;
        break;
      default:
        break;
      }
    }
    if (_year > 0) {
      const _data = { id: classId, subject: subjectName, category: categoryName, year: Number(_year), subjectId }
      const response = await commonApi.fetchCategoryMark(_data);
      const result = response?.Items;
      !isEmptyArray(result) && setTableBodyData(result?.filter((ele, i) => {
        if (i !== 0) {
          if (!isNullOrEmpty(ele) && ele.category[0]?.name === categoryName && ele) { return ele } return ele;
        } else { return ele }
      }));
    }
    setIsLoading(false)
  }

  const handleTabSelect = (category, i) => {
    dispatch(setCategory(category));
    dispatch(setCategoryIndex(i));
    setCategoryName(category);
  };

  const textWrap = (text) => { return text.length > 20 ? text.slice(0, 22) + "..." : text }

  useEffect(() => {
    let uniqueHeader = mainHeadersData?.filter((ele) => ele.name === markingData.categoryNameOne && ele.description);
    let headers = uniqueHeader[0]?.description.map((ele) => { return { category: ele.name, description: ele.name, isKPI: ele.isKPI, identifier: ele.identifier } });
    headers?.push({ description: `${markingData.categoryNameOne} ${Marking.Attainment}`, actual: Marking.Actual, predicted: Marking.Predicted, isKPI: false, identifier: Marking.Ff });
    headers?.unshift({ description: " ", isKPI: false, identifier: Marking.Dd });
    setTempHeadersData(headers)
    const filterData = (!isNullOrEmpty(_subjectClassId) || !isNullOrEmpty(className) || !isNullOrEmpty(subjectName) || !isNullOrEmpty(_classId)) && _fetchCategoryMark(subjectName, _classId, markingData.categoryNameOne, year && year, markingData.subjectId)
    setTableBodyData(filterData);
  }, [markingData.categoryNameOne]);

  useEffect(() => {
    const className = markingData.className;
    const subjectName = markingData.subjectName;
    const classId = markingData.classId;
    const subjectId = markingData.subjectId;
    setClassId(classId);
    setSubjectName(subjectName);
    setSubjectClassId(subjectId);
    setClassName(className);
    getHeadersAndTabs(markingData.subjectId, markingData.categoryNameOne);
    dispatch(setSelect(NavigationBar.MyClasses))
  }, [markingData.classNavId])

  useEffect(() => {
    (isNullOrEmpty(markingData.categoryIndex) && !isEmptyArray(tabsData)) && setCategoryName(tabsData[0]?.name);
  }, [tabsData])

  return (
    <div className="Page-layout">
      {isLoading && <LoadingSpinner />}
      <div className="Page-header">
        <Header />
        <div className="marking-page">
          <div className="marking-header">
            <div className="marking-title">
              <span className="_className">{className}</span>
              <span className="subjectName">{`${subjectName} ${Marking.Marksheet}`}</span>
            </div>
          </div>
          <div className="marking-content">
            <div className="year-dropdown-div">
              <div style={{ marginRight: isNavCollapsed ? "-80px" : "80px" }}>
                {markingData.categoryNameOne ?
                  <Tabs className="marking-tab">
                    <TabList className="marking-tablist">
                      {tabsData.map((ele, i) => {
                        return <Tab className={ele.name === markingData.categoryNameOne ? "react-tab__tab--selected" : "marking-tabs"} key={i} onClick={() => handleTabSelect(ele.name, i)}
                          style={(ele.name === markingData.categoryNameOne && markingData.categoryNameOne) ? { backgroundColor: "#F3F3F3", color: "#084059" } : { backgroundColor: "#084059", color: "#ffffff" }} title={ele.name}>{textWrap(ele.name)}</Tab>
                      })}
                    </TabList>
                    {
                      (!isEmptyArray(tableBodyData[0]?.description) ?
                        (<MarkingTable tabsData={tabsData} headersData={tempHeadersData && tempHeadersData.length > 0 ? tempHeadersData : headersData} tableBodyData={tableBodyData} categoryName={categoryName && categoryName} _subjectClassId={_subjectClassId} _classId={_classId} subjectName={subjectName} year={year} />) : (
                          <div className="d-flex justify-content-center">
                            <h1>{Common.NoPupil}</h1>
                          </div>
                        ))
                    }
                  </Tabs> :
                  <Tabs className="marking-tab">
                    <TabList className="marking-tablist">
                      {tabsData.map((ele, i) => { return <Tab className={ele.name === markingData.categoryNameOne ? "react-tab__tab--selected" : "marking-tabs"} key={i} onClick={() => handleTabSelect(ele.name, i)}>{textWrap(ele.name)}</Tab> })}
                    </TabList>
                    {(!isEmptyArray(tableBodyData[0]?.description) ?
                      (<MarkingTable tabsData={tabsData} headersData={tempHeadersData && tempHeadersData.length > 0 ? tempHeadersData : headersData} tableBodyData={tableBodyData} categoryName={categoryName && categoryName} _subjectClassId={_subjectClassId} _classId={_classId} subjectName={subjectName} year={year} />) : (
                        <div className="d-flex justify-content-center">
                          <h1>{Common.NoPupil}</h1>
                        </div>
                      ))
                    }
                  </Tabs>
                }
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export { Markings };